import {API_ROOT} from "../../baseUrls";

export const LOAD_HELP_FILE = 'LOAD_HELP_FILE'
export const GET_HELP_EDITS = 'GET_HELP_EDITS'
export const ADD_HELP_EDITS = 'ADD_HELP_EDITS'

export function loadHelpEdits(callback=()=>{}) {
  return function(dispatch, getState) {
    fetch(`${ API_ROOT }/help/edit/load`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': getState().auth.authenticity_token},
    })
      .then(resp => resp.json())
      .then(data => dispatch({type: GET_HELP_EDITS, payload: data}))
      .catch((e) => console.error(e))
      .then(callback());
  }
}

// async function loadHelpFile(file) {
//   return await fetch(`/v2/help_files/help_${file}.json?ts=${new Date().getTime()}`, {
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json"
//     }
//   }).then(resp => resp.json());
// }
export function loadHelpFile(file, callback=()=>{}) {
  return function(dispatch, getState) {
    fetch(`/v2/help_files/help_${file}.json?ts=${new Date().getTime()}`, {
      Accept: "application/json",
      credentials: 'include',
      headers: {
        'X-CSRF-Token': getState().auth.authenticity_token,
        "Content-Type": "application/json",
      },
    })
      .then(resp => resp.json())
      .then(data => dispatch({type: LOAD_HELP_FILE, payload: {user: getState().auth, [file]: data}}))
      .catch((e) => console.error(e))
      .then(callback());
  }
}

export function addHelpEdit(key, title, text, opts, callback=()=>{}) {
  return function(dispatch, getState) {
    const edit = {
      key: key,
      title: title,
      text: text,
      opts: opts
    };
    fetch(`${ API_ROOT }/help/edit/add`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': getState().auth.authenticity_token
      },
      body: JSON.stringify(edit),
    })
      .then(resp => resp.json())
      .then(data => dispatch({type: ADD_HELP_EDITS, payload: data}))
      .catch((e) => console.error(e))
      .then(callback());
  }
}

export function helpEdits(state = null, action) {
  switch (action.type) {
    case GET_HELP_EDITS:
      return action.payload;
    case ADD_HELP_EDITS:
      return {...state, [action.payload.key]: action.payload}
    default:
      return  state;
  }
}

function updateHelpData(newState){
  if(!!newState.edits){
    Object.entries(newState.edits).forEach(([key, {title, text, opts}]) => {
      newState.titles[key] = title;
      newState.text[key] = text;
      newState.opts[key] = opts;
    })
  }
  const [newSections, pathMap, orderMap] = loadHelpSections(newState.structure, newState.titles, newState.text, newState.opts, newState.user)
  newState.sections = newSections;
  newState.pathMap = pathMap;
  newState.orderMap = orderMap;
}

export function helpData(state = null, action) {
  switch (action.type) {
    case LOAD_HELP_FILE:
      const newState = {...state, ...action.payload};
      if(newState?.structure && newState?.text && newState?.titles && newState?.opts && newState?.user && !newState?.sections){
        updateHelpData(newState);
      }
      return newState;
    case GET_HELP_EDITS:
      const editState = {...state, edits: action.payload}
      if(!!editState?.sections) {
        updateHelpData(editState);
      }
      return editState;
    case ADD_HELP_EDITS:
      const newEditState = {...state, edits: {...state.edits, [action.payload.key]: action.payload}}
      if(!!newEditState?.sections) {
        updateHelpData(newEditState);
      }
      return newEditState;
    default:
      return  state;
  }
}

function loadHelpSections(helpStructure, helpTitles, helpTexts, helpOpts, user){
  // const helpStructure = await loadHelpFile("sections");
  // const helpTitles = await loadHelpFile("titles");
  // const helpTexts = await loadHelpFile("text");

  const newSections = {...(helpStructure||{})};
  Object.entries(newSections).forEach(([id, section]) => {
    populateSection([], id, section, helpTitles, helpTexts, helpOpts);
  })
  const orderMap = getOrderMap(newSections);
  const pathMap = getPathMap(newSections);
  Object.entries(newSections).forEach(([id, section]) => {
    resolveSection(id, section, pathMap, orderMap, user);
  })
  return [newSections, pathMap, orderMap];
}
const buildPathMap = (section, pathMap, title=null) => {
  const cleanTitle = section.title.replaceAll(" ", "").replaceAll(".","");
  const pathStr = title === null ? cleanTitle : title + "." + cleanTitle;
  pathMap[pathStr] = section;
  Object.entries(section.images||{}).forEach(([id,s]) => {
    buildPathMap(s, pathMap, pathStr);
  })
  Object.entries(section.sections||{}).forEach(([id,s]) => {
    buildPathMap(s, pathMap, pathStr);
  })
}
const getPathMap = (helpSections) => {
  const pathMap = {};
  Object.entries(helpSections||{}).forEach(([id, s]) => buildPathMap(s, pathMap));
  return pathMap;
}
const buildOrderMap = (section, orderMap) => {
  orderMap[section.fullOrder] = section;
  Object.entries(section.images||{}).forEach(([id,s]) => {
    buildOrderMap(s, orderMap);
  })
  Object.entries(section.sections||{}).forEach(([id,s]) => {
    buildOrderMap(s, orderMap);
  })
}
const getOrderMap = (helpSections) => {
  const orderMap = {};
  Object.entries(helpSections||{}).forEach(([id, s]) => buildOrderMap(s, orderMap));
  return orderMap;
}

const populateSection = (parentPath, sectionId, section, helpTitles, helpTexts, helpOpts) => {
  const title = helpTitles[sectionId];
  const text = helpTexts[sectionId];
  const opts = helpOpts[sectionId];
  section.title = title;
  section.rawText = text;
  section.text = text;
  section.opts = opts;
  const path = [...(parentPath||[]), {name: section.name, title: section.title, order: section.fullOrder}];
  section.path = path;
  Object.entries(section.images||{}).forEach(([sId, section]) => {
    populateSection(path, sId, section, helpTitles, helpTexts, helpOpts);
  })
  Object.entries(section.sections||{}).forEach(([sId, section]) => {
    populateSection(path, sId, section, helpTitles, helpTexts, helpOpts);
  })
}

const resolveChildRefs = (parentRef, sectionId, section, pathMap, orderMap) => {
  if(!section.text){
    // console.error("Missing section text:", sectionId);
    return;
  }
  const refMatch = section.text.match(/[{](text|ref|link) +[*][}]/);
  if(!refMatch){
    return
  }
  const fullRef = refMatch[0];
  const refType = refMatch[1];
  const cleanTitle = section.name;
  if(parentRef.match(/^[0-9.]+$/)){
    const refParent = orderMap[parentRef];
    if(!refParent){
      console.error("Missing reference:" + parentRef);
      return;
    }
    const parentPathRef = refParent.path.map(p => p.name).join(".");
    const refPath = parentPathRef + "." + cleanTitle;
    section.text = section.text.replace(fullRef, `{${refType} ${refPath}}`);
  }else{
    const refPath = parentRef + "." + cleanTitle;
    section.text = section.text.replace(fullRef, `{${refType} ${refPath}}`);
  }
}

const updateSectionReference = (sectionId, section, fullRef, idRef, text, pathMap, orderMap, user) => {
  section.text = section.text.replace(fullRef, text).trim();
  if(!!idRef) {
    Object.entries(section.images || {}).forEach(([sId, child]) => {
      resolveChildRefs(idRef, sId, child, pathMap, orderMap)
    })
    Object.entries(section.sections || {}).forEach(([sId, child]) => {
      resolveChildRefs(idRef, sId, child, pathMap, orderMap)
    })
  }
  resolveSection(sectionId, section, pathMap, orderMap, user);
}

const addLink = (fullRef, sectRef, refSection) => {
  if(!refSection){
    console.error("Link reference missing:", sectRef);
    return `[${sectRef}](#help_${sectRef})`
  }
  return `[${refSection.title}](#help_${refSection.fullOrder})`;
}

const resolveSection = (id, section, pathMap, orderMap, user) => {
  if(!section.text){
    // console.error("Missing section text:", id);
  }else {
    const orderMatch = section.text.match(/[{](text|ref|link) +(([0-9]+[.]?)+)[}]/);
    if (orderMatch) {
      const fullRef = orderMatch[0];
      const refType = orderMatch[1];
      const refOrder = orderMatch[2];
      const text = refType === "ref" ? "" : refType === "link" ?
        addLink(fullRef, refOrder, orderMap[refOrder])
        : orderMap[refOrder]?.text || "";
      updateSectionReference(id, section, fullRef, refOrder, text, pathMap, orderMap, user);
      return;
    }

    // eslint-disable-next-line no-useless-escape
    const pathMatch = section.text.match(/[{](text|ref|link) +(([A-Za-z][A-Za-z0-9 ,\[\]()_-]*[.>]? *)+)[}]/);
    if (pathMatch && pathMatch.length > 2) {
      const fullRef = pathMatch[0];
      const refType = pathMatch[1];
      const pathRef = pathMatch[2].replaceAll(" ", "").replaceAll(">", ".");

      const text = refType === "ref" ? "" : refType === "link" ?
        addLink(section.text, fullRef, pathRef, pathMap[pathRef])
        : pathMap[pathRef].text || "";
      updateSectionReference(id, section, fullRef, pathRef, text, pathMap, orderMap, user);
      return;
    }

    if (section.text.match(/[{]username[}]/)) {
      updateSectionReference(id, section, "{username}", null, user.username, pathMap, orderMap, user);
      return;
    }
  }
  Object.entries(section.images||{}).forEach(([sId, section]) => {
    resolveSection(sId, section, pathMap, orderMap, user);
  })
  Object.entries(section.sections||{}).forEach(([sId, section]) => {
    resolveSection(sId, section, pathMap, orderMap, user);
  })
}